export default __webpack_public_path__ + "static/media/rakshith.6e1bdce2.jpg";